import { alpha, Card, CardContent, useTheme } from '@mui/material';

import { USER_LOAN_PROGRAM } from '@/config/constants';
import { ProductEsitmation } from '@/types/ProductType';
import { StackedFeeItem } from './StackedFeeItem';

type ProductDetailOtherCostsProps = {
  estimation: ProductEsitmation;
};

export const ProductDetailOtherCosts = ({
  estimation,
}: ProductDetailOtherCostsProps) => {
  const theme = useTheme();

  if (!estimation) return null;

  return (
    <Card
      sx={{
        background: alpha(theme.palette.primary.main, 0.03),
        color: theme.palette.text.primary,
        borderRadius: 2,
        border: `1px solid ${theme.palette.greyShades.border1}`,
        boxShadow: `0 4px 24px ${alpha(theme.palette.common.black, 0.06)}`,
        overflow: 'hidden',
      }}
    >
      <CardContent sx={{ p: { xs: 2, sm: 2.5, md: 3 } }}>
        <StackedFeeItem
          label="Credit Report Fee"
          value={estimation.creditReportFeeBase}
          feeKey="creditReportFeeBase"
        />
        <StackedFeeItem
          label="Initial Purchase Contract Deposit (Earnest Money)"
          value={estimation.earnestMoneyDeposit}
        />
        <StackedFeeItem
          label="Home Inspection Fee"
          value={
            (estimation as { homeInspectionFee?: number }).homeInspectionFee ||
            0
          }
        />
        <StackedFeeItem
          label="Appraisal Report"
          value={estimation.appraisalFeeBase}
          feeKey="appraisalFeeBase"
        />
        {estimation.type === USER_LOAN_PROGRAM.DSCR && (
          <StackedFeeItem
            label="Rental Income Report Fee"
            value={
              (estimation as { rentalIncomeReportFee?: number })
                .rentalIncomeReportFee || 0
            }
            feeKey="rentalIncomeReportFee"
          />
        )}
        {estimation.type === USER_LOAN_PROGRAM.COMMERCIAL && (
          <StackedFeeItem
            label="Commitment Fee"
            value={
              (estimation as { commitmentFee?: number }).commitmentFee || 0
            }
            feeKey="commitmentFee"
          />
        )}
      </CardContent>
    </Card>
  );
};
